export default __webpack_public_path__ + "static/media/KOD0139-min.c873c8d4.webp";